import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html {
    font-size: 72.5%;
    // min-height: 100vh;
    // height: -webkit-fill-available;  
  }
  
  body {
    margin: 0;
    padding: 0;
    font-size: ${(props) => props.theme.font.size.medium};
    font-family: Helvetica;
    height: 100%;
    display:block;
    overflow:auto;
    background: black;
    *, :after, :before {
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
    }
      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        border-radius: 10px;
        background-color: transparent;
      }

      &::-webkit-scrollbar-track:horizontal {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        border-radius: 10px;
        background-color: transparent;
      }

      &::-webkit-scrollbar {
        border-radius: 10px;
        width: 12px;
        background-color: transparent;
      }
      &::-webkit-scrollbar:horizontal {
        border-radius: 10px;
        height: 12px;
        background-color: transparent;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #57626B;
      }
      &::-webkit-scrollbar-thumb:horizontal {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #57626B;
      }

    & * {
      &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
      border-radius: 10px;
      background-color: transparent;
      }

      &::-webkit-scrollbar-track:horizontal {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        border-radius: 10px;
        background-color: transparent;
        }

      &::-webkit-scrollbar {
        border-radius: 10px;
        width: 12px;
        background-color: transparent;
      }
      &::-webkit-scrollbar:horizontal {
        border-radius: 10px;
        height: 12px;
        background-color: transparent;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #57626B;
      }
      &::-webkit-scrollbar-thumb:horizontal {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #57626B;
      }
    }
  }
  
  input, select, textarea, button {
    font-family: inherit;
    font-size: inherit;
  }

  .hide {
    display: none;
  }

  
.CalendarDay__selected_span {
  /* background: blue; */
  /* color: red; */
  border-color: #e4e7e7;
}


/* Will edit selected date or the endpoints of a range of dates */
.CalendarDay__selected {
  /* background: blue;
  color: red; */
  border-color: #e4e7e7;
}

/* Will edit when hovered over. _span style also has this property */
.CalendarDay__selected:hover,
.CalendarDay__default:hover {
  /* background: blue;
  color: red; */
  border-color: #e4e7e7;
}

/* Will edit when the second date (end date) in a range of dates
is not yet selected. Edits the dates between your mouse and said date */
.CalendarDay__hovered_span:hover,
.CalendarDay__hovered_span {
  /* background: blue;
  color: red; */
  border-color: #e4e7e7;
}

/* EXTERIOR INPUT STYLE */
/* Container - placement */
.DateRangePicker {
  margin:0 !important;
  padding:0 !important;
  min-width: 100%;
}
/* Container - visual */
.DateRangePickerInput {
  margin:0;
  padding:0;
}

.DateRangePickerInput.DateRangePickerInput__withBorder {
  margin:0;
  padding:0;
  cursor: pointer;
  border-radius: 4px;
  color: white;
  border: 1px solid white;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: calc(100% - 10px);
}

/* Input Container */
.DateInput {
  position: relative;
  height: 32px;
  vertical-align: middle;
  font-size: ${(props) => props.theme.font.size.small};
  width: calc(100% - 10px);
}
.DateRangePickerInput_arrow {
  display:none;
}

/* Actual Input Element */
.DateInput > .DateInput_input {
  font-size: ${(props) => props.theme.font.size.medium};
  padding: 0 0 0 10px; 
  margin: 0 !important;
  border: none;
  color: white; 
}

/* PRESETS */
.PresetDateRangePicker_panel {
  display: flex;
  flex-flow:row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0 !important;
  width: 100%;
}

.CalendarDay__blocked_out_of_range:hover {
  background: #fff;
  cursor: not-allowed;
}

.DateRangePicker_select {
  background: white;
  color: black;
  border: 1px solid #e4e7e7;
  border-radius: 4px;
  padding: 3px 20px 3px 10px;
  font-size: 14px;
  cursor: pointer;
  appearance: none;

  background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%);
  background-position: calc(100% - 11px) 11px, calc(100% - 6px) calc(11px);
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
}

.DateRangePicker_select:hover {
  border-color: #c4c4c4;
}
`;

export default GlobalStyle;
